import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    Grid,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Switch,
    FormControlLabel,
    IconButton,
    Divider,
    Stack,
    Snackbar,
    Alert
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";


import { rtdb, storage } from "../../services/firebase";
import { ref, set, get } from "firebase/database";
import {
    ref as storageRef,
    uploadBytes,
    getDownloadURL
} from "firebase/storage";

import { useNavigate } from "react-router-dom";
import { productHasVapeCategory } from "../../utils/productCategories";


export default function ProductForm() {

    const [id, setId] = useState("");
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loadingData, setLoadingData] = useState(true);

    const navigate = useNavigate();


    const [saving, setSaving] = useState(false);

    const [nome, setNome] = useState("");
    const [preco, setPreco] = useState("");
    const [isPromo, setIsPromo] = useState(false);
    const [precoPromo, setPrecoPromo] = useState("");
    const [precoDiscount, setPrecoDiscount] = useState("");

    const [marca, setMarca] = useState("");
    const [categorias, setCategorias] = useState([]);

    const [descricao, setDescricao] = useState("");

    const [imagens, setImagens] = useState([]);
    const [variacoes, setVariacoes] = useState([{ nome: "", quantidade: "" }]);
    const [specs, setSpecs] = useState([{ key: "", value: "" }]);

    const [feedback, setFeedback] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const showFeedback = (message, severity = "success") => {
        setFeedback({
            open: true,
            message,
            severity
        });
    };

    useEffect(() => {
        const random = Math.random().toString(36).substring(2, 10).toUpperCase();
        setId(random);
        carregarMarcasECategorias();
    }, []);

    async function carregarMarcasECategorias() {
        try {
            const appSnap = await get(ref(rtdb, "app"));
            if (appSnap.exists()) {
                const data = appSnap.val();
                setBrands(Array.isArray(data.brands) ? data.brands.map((nome) => ({ id: nome.toLowerCase().replace(/\s+/g, "_"), nome })) : []);
                setCategories(Array.isArray(data.category) ? data.category.map((nome) => ({ id: nome.toLowerCase().replace(/\s+/g, "_"), nome })) : []);
            }
        } catch (err) {
            console.error("Erro ao carregar marcas e categorias:", err);
        } finally {
            setLoadingData(false);
        }
    }

    const handleImages = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + imagens.length > 5) {
            showFeedback("Você pode adicionar no máximo 5 imagens.", "warning");
            return;
        }
        setImagens([...imagens, ...files]);
    };

    const formatMoney = (value) => {
        if (!value) return "";
        value = value.replace(/\D/g, "");
        value = (value / 100).toFixed(2).replace(".", ",");
        return "R$ " + value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    async function uploadProductImages(productId, files) {
        const urls = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            const imageRef = storageRef(
                storage,
                `products/${productId}/${Date.now()}_${file.name}`
            );

            await uploadBytes(imageRef, file);

            const downloadURL = await getDownloadURL(imageRef);
            urls.push(downloadURL);
        }

        return urls;
    }

    async function handleSave() {

        if (imagens.length < 1 || imagens.length > 5) {
            showFeedback("Adicione no mínimo 1 e no máximo 5 imagens.", "warning");
            return;
        }

        if (!nome || !marca || !categorias.length || !preco) {
            showFeedback("Preencha todos os campos obrigatórios.", "warning");
            return;
        }

        setSaving(true);

        const imageUrls = await uploadProductImages(id, imagens);

        const data = {
            id,
            nome,
            marca,
            categorias,
            categoria: categorias[0] || "",
            descricao,
            status: "active",
            variacoes: variacoes.filter(v => v.nome),
            precos: {
                normal: preco,
                isPromo,
                promo: isPromo ? precoPromo : null,
                discount: precoDiscount ? precoDiscount : null
            },
            imagens: imageUrls,
            specs: specs.filter(s => s.key),
            createdAt: Date.now()
        };

        try {
            await set(ref(rtdb, `products/${id}`), data);

            showFeedback("Produto criado com sucesso!", "success");



            const newId = Math.random().toString(36).substring(2, 10).toUpperCase();
            setId(newId);

            setNome("");
            setMarca("");
            setCategorias([]);
            setDescricao("");

            setPreco("");
            setIsPromo(false);
            setPrecoPromo("");
            setPrecoDiscount("");

            setImagens([]);
            setVariacoes([{ nome: "", quantidade: "" }]);
            setSpecs([{ key: "", value: "" }]);

            setTimeout(() => {
                navigate("/admin/produtos");
            }, 900);

        } catch (err) {
            console.error(err);
            showFeedback("Erro ao salvar produto. Tente novamente.", "error");
        }

        setSaving(false);
    }

    const labelStyles = {
    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
};

    return (
        <Box sx={{ mt: { xs: 2, md: 4 }, pr: { xs: 0, md: 4 }, width: "100%", maxWidth: "100%", overflow: "auto" }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "1.35rem", md: "1.5rem" } }}>
                Criar Produto
            </Typography>

            <Paper elevation={1} sx={{ p: { xs: 2, sm: 3, md: 4 }, borderRadius: 3 }}>

                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Informações do Produto
                </Typography>

                <Grid container spacing={3} alignItems="center">

                    {/* ID */}
                    <Grid item xs={12} md={3}>
                        <TextField
                            label="ID"
                            fullWidth
                            value={id}
                            disabled
                            InputLabelProps={{ shrink: true }}
                            sx={labelStyles}
                        />
                    </Grid>

                    {/* Nome */}
                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Nome do Produto"
                            placeholder="Nome do produto"
                            fullWidth
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={labelStyles}
                        />
                    </Grid>

                    {/* Marca */}
                    <Grid item xs={12} md={4}>
                        <FormControl
                            fullWidth
                            sx={labelStyles}
                        >
                            <InputLabel shrink>Marca</InputLabel>
                            <Select
                                value={marca}
                                displayEmpty
                                onChange={(e) => setMarca(e.target.value)}
                                sx={{ height: 56 }}
                                disabled={loadingData}
                            >
                                <MenuItem value=""><em>Selecione uma marca</em></MenuItem>
                                {brands.map(b => (
                                    <MenuItem key={b.id} value={b.nome}>{b.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Categorias (múltiplas) */}
                    <Grid item xs={12} md={8}>
                        <FormControl
                            fullWidth
                            sx={labelStyles}
                        >
                            <InputLabel id="pf-cat-label" shrink>Categorias</InputLabel>
                            <Select
                                labelId="pf-cat-label"
                                id="pf-cat-select"
                                multiple
                                label="Categorias"
                                value={categorias}
                                onChange={(e) => {
                                    const v = e.target.value;
                                    setCategorias(typeof v === "string" ? v.split(",") : v);
                                }}
                                displayEmpty
                                renderValue={(selected) =>
                                    !selected || selected.length === 0 ? (
                                        <em style={{ color: "rgba(0,0,0,0.38)" }}>Selecione ao menos uma categoria</em>
                                    ) : (
                                        selected.join(" · ")
                                    )
                                }
                                sx={{ minHeight: 56 }}
                                disabled={loadingData}
                                MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
                            >
                                {categories.map((c) => (
                                    <MenuItem key={c.id} value={c.nome}>
                                        {c.nome}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Descrição do Produto"
                            placeholder="Digite uma descrição detalhada..."
                            fullWidth
                            multiline
                            minRows={4}
                            maxRows={8}
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            sx={labelStyles}
                        />
                    </Grid>

                </Grid>




                <Divider sx={{ my: 4 }} />


                {/* ========================  VARIAÇÕES ======================== */}
                {categorias.length > 0 && (
                    <>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                            Variações ({productHasVapeCategory({ categorias }) ? "Cores" : "Sabores"})
                        </Typography>

                        {variacoes.map((v, i) => (
                            <Grid container spacing={2} key={i} sx={{ mb: 1 }}>

                                <Grid item xs={12} md={5}>
                                    <TextField
                                        label={productHasVapeCategory({ categorias }) ? "Cor" : "Sabor"}
                                        fullWidth
                                        value={v.nome}
                                        onChange={e => {
                                            const arr = [...variacoes];
                                            arr[i].nome = e.target.value;
                                            setVariacoes(arr);
                                        }}
                                        sx={labelStyles}
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <TextField
                                        label="Quantidade"
                                        fullWidth
                                        value={v.quantidade}
                                        onChange={e => {
                                            const onlyNums = e.target.value.replace(/\D/g, ""); // remove qualquer coisa que não seja número
                                            const arr = [...variacoes];
                                            arr[i].quantidade = onlyNums;
                                            setVariacoes(arr);
                                        }}
                                        inputProps={{
                                            inputMode: "numeric",     // teclado numérico no mobile
                                            pattern: "[0-9]*"         // só permite dígitos
                                        }}
                                        sx={labelStyles}
                                    />
                                </Grid>

                                <Grid item xs={12} md={1} sx={{ display: "flex", alignItems: "center" }}>
                                    <IconButton onClick={() => setVariacoes(variacoes.filter((_, idx) => idx !== i))}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Grid>

                            </Grid>
                        ))}

                        <Button startIcon={<AddIcon />} sx={{ mt: 1 }} onClick={() => setVariacoes([...variacoes, { nome: "", quantidade: "" }])}>
                            Adicionar Variação
                        </Button>

                    </>
                )}


                <Divider sx={{ my: 4 }} />


                {/* ========================  VALORES DO PRODUTO ======================== */}
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Valores do Produto
                </Typography>

                <Grid container spacing={3} alignItems="center">

                    {/* Preço */}
                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Preço Varejo"
                            placeholder="R$ 0,00"
                            fullWidth
                            value={preco}
                            onChange={(e) => setPreco(formatMoney(e.target.value))}
                            InputLabelProps={{ shrink: true }}
                            sx={labelStyles}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Preço Atacado"
                            placeholder="R$ 0,00"
                            fullWidth
                            value={precoDiscount}
                            onChange={(e) => setPrecoDiscount(formatMoney(e.target.value))}
                            InputLabelProps={{ shrink: true }}
                            sx={labelStyles}
                        />
                    </Grid>

                    {/* Promoção */}
                    <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "center" }}>
                        <FormControlLabel
                            control={<Switch checked={isPromo} onChange={(e) => setIsPromo(e.target.checked)} />}
                            label="Promoção?"
                        />
                    </Grid>

                    {/* Preço Promocional */}
                    {isPromo && (
                        <Grid item xs={12} md={3}>
                            <TextField
                                label="Preço Promocional (Varejo)"
                                placeholder="R$ 0,00"
                                fullWidth
                                value={precoPromo}
                                onChange={(e) => setPrecoPromo(formatMoney(e.target.value))}
                                InputLabelProps={{ shrink: true }}
                                sx={labelStyles}
                            />
                        </Grid>
                    )}

                </Grid>


                <Divider sx={{ my: 4 }} />



                {/* ========================  ESPECIFICAÇÕES ======================== */}
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Especificações</Typography>

                {specs.map((s, i) => (
                    <Grid container spacing={2} key={i} sx={{ mb: 1 }}>
                        <Grid item xs={12} md={4}>
                            <TextField label="Título" fullWidth value={s.key}
                                onChange={e => {
                                    const arr = [...specs];
                                    arr[i].key = e.target.value;
                                    setSpecs(arr);
                                }}
                                sx={labelStyles}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField label="Valor" fullWidth value={s.value}
                                onChange={e => {
                                    const arr = [...specs];
                                    arr[i].value = e.target.value;
                                    setSpecs(arr);
                                }}
                                sx={labelStyles}
                            />
                        </Grid>
                        <Grid item xs={12} md={1} sx={{ display: "flex", alignItems: "center" }}>
                            <IconButton onClick={() => setSpecs(specs.filter((_, idx) => idx !== i))}>
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}

                <Button startIcon={<AddIcon />} sx={{ mt: 1 }} onClick={() => setSpecs([...specs, { key: "", value: "" }])}>
                    Adicionar Especificação
                </Button>


                <Divider sx={{ my: 4 }} />


                {/* ========================  IMAGENS ======================== */}
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Imagens (1–5)</Typography>

                <Button variant="outlined" component="label" sx={{ mb: 2 }}>
                    Selecionar Imagens
                    <input hidden type="file" multiple accept="image/*" onChange={handleImages} />
                </Button>


                <Stack direction="row" spacing={2} flexWrap="wrap">
                    {imagens.map((img, i) => (
                        <Box key={i} sx={{ position: "relative" }}>
                            <img
                                src={URL.createObjectURL(img)}
                                alt=""
                                style={{ width: 100, height: 100, borderRadius: 8, objectFit: "cover", border: "1px solid #ccc" }}
                            />
                            <IconButton
                                size="small"
                                onClick={() => setImagens(imagens.filter((_, idx) => idx !== i))}
                                sx={{
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                    bgcolor: "white",
                                    boxShadow: 2
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    ))}
                </Stack>
            </Paper>


            {/* ========================  BOTÃO SALVAR ======================== */}
            <Box
                sx={{
                    position: "fixed",
                    bottom: { xs: 16, md: 24 },
                    right: { xs: 16, md: 32 },
                    zIndex: 1300
                }}
            >
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleSave}
                    disabled={saving}
                    sx={{
                        px: 4,
                        py: 1.6,
                        borderRadius: 3,
                        fontWeight: 600,
                        boxShadow: "0 12px 30px rgba(0,0,0,0.25)"
                    }}
                >
                    {saving ? "Salvando..." : "Salvar Produto"}
                </Button>
            </Box>



            {/* ========================  FEEDBACK ======================== */}
            <Snackbar
                open={feedback.open}
                autoHideDuration={4000}
                onClose={() => setFeedback({ ...feedback, open: false })}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setFeedback({ ...feedback, open: false })}
                    severity={feedback.severity}
                    variant="filled"
                    sx={{
                        borderRadius: 2,
                        fontWeight: 500
                    }}
                >
                    {feedback.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
